import { render, staticRenderFns } from "./AlarmBoardPopup.vue?vue&type=template&id=cbba007c"
import script from "./AlarmBoardPopup.vue?vue&type=script&lang=js"
export * from "./AlarmBoardPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports